
/* ============================================================
   AI PIA — 공통 UI 컴포넌트 (KRDS)
   ※ 비즈니스 로직 없음. 렌더링 헬퍼만 제공.
   ============================================================ */
(function(){
  'use strict';
  var PIA = window.PIA = window.PIA || {};

  var esc = _escHtml;
  PIA.esc = esc;

  /* --- Icon set --- */
  var IC = {
    fontsize:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 20 9 6l5 14"/><path d="M6 15h6"/><path d="M17 12h5M19.5 9.5v5"/></svg>',
    sound:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5 6 9H3v6h3l5 4z"/><path d="M16 9a4 4 0 0 1 0 6"/><path d="M19 6.5a8 8 0 0 1 0 11"/></svg>',
    help:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M9.5 9a2.5 2.5 0 1 1 3.4 2.3c-.6.3-.9.8-.9 1.4v.3"/><circle cx="12" cy="17" r=".6" fill="currentColor"/></svg>',
    back:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18 9 12l6-6"/></svg>',
    save:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M18 16a4 4 0 0 0-1-7.9A6 6 0 0 0 5.5 9 4 4 0 0 0 6 16z"/><path d="m9 13 2 2 4-4"/></svg>',
    shield:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 12 2 2 4-4"/></svg>',
    warn:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 8v5"/><circle cx="12" cy="16.5" r=".7" fill="currentColor"/></svg>',
    clock:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v5.2l3.2 2"/></svg>'
  };
  /* 전체 화면(네 모서리) — 2026-10-01 */
  IC.fullscreen = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 9V4h5"/><path d="M20 9V4h-5"/><path d="M4 15v5h5"/><path d="M20 15v5h-5"/></svg>';
  IC.compass = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="m15.5 8.5-2 5.5-5.5 2 2-5.5z"/></svg>';
  PIA.icon = function(n){ return IC[n]||''; };

  /* --- AppHeader --- */
  PIA.header = function(){
    var big = document.documentElement.getAttribute('data-pia-fs')==='l';
    return '<header class="pia-hdr"><div class="pia-hdr__in">'
      + '<div class="pia-hdr__brand"><span class="pia-hdr__logo">예담 톡</span>'
      + '<span class="pia-hdr__sub" data-i18n="header.tagline">AI 기반 인ㆍ적성 검사</span></div>'
      + '<div class="pia-hdr__acts">'
      /* [2026-09-26] 폭 1079px 이하에서는 버튼 글자(span)를 display:none 으로 감춰 아이콘만 남는다.
         그러면 화면낭독기에 이름이 없는 버튼이 된다. 보이는 글자와 같은 aria-label 을 달고
         (data-i18n-aria 로 언어 전환 때 함께 바뀐다) 장식 아이콘은 숨긴다.
         언어 버튼은 보이는 글자(KO/EN)가 이름 앞에 오도록 맞춘다(i18n.js 가 전환 때 갱신). */
      + '<button type="button" class="pia-hdr-btn" id="pia-lang-btn" data-act="?aipiaToggleLanguage" aria-label="KO \u00b7 \uC5B8\uC5B4 \uBCC0\uACBD / Language">'
      + '<span aria-hidden="true" style="display:inline">\uD83C\uDF10</span><span id="pia-lang-label">KO</span></button>'
      /* [2026-10-01] OWNER '이 버튼을 전체 화면 버튼으로' — 휴대폰·태블릿·PC 에서는 '전체 화면'(주소창·하단 메뉴 숨김)을 보이고,
         '글자 크게'는 전체 화면이 필요 없는 곳(키오스크·홈 화면 앱)에서만 보인다(pia-token.css). 저장된 글자 크게 설정은 그대로 적용된다. */
      + '<button type="button" class="pia-hdr-btn" id="pia-fullscreen-btn" aria-label="전체 화면" data-i18n-aria="common.fullscreen" aria-pressed="'+(PIA.isFullscreen()?'true':'false')+'" data-act="PIA.toggleFullscreen">'
      + IC.fullscreen + '<span data-i18n="common.fullscreen">전체 화면</span></button>'
      + '<button type="button" class="pia-hdr-btn" id="pia-fs-btn" aria-label="글자 크게" data-i18n-aria="common.textSize" aria-pressed="'+(big?'true':'false')+'" data-act="PIA.toggleFontSize">'
      + IC.fontsize + '<span data-i18n="common.textSize">글자 크게</span></button>'
      + '<button type="button" class="pia-hdr-btn" id="pia-tts-btn" aria-label="음성 안내" data-i18n-aria="common.voiceGuide" aria-pressed="'+(PIA.ttsOn?'true':'false')+'" data-act="PIA.toggleTTS">'
      + IC.sound + '<span data-i18n="common.voiceGuide">음성 안내</span></button>'
      + '<button type="button" class="pia-hdr-btn" id="pia-help-btn" aria-label="도움" data-i18n-aria="common.help" data-act="PIA.openHelp">'
      + IC.help + '<span data-i18n="common.help">도움</span></button>'
      + '</div></div></header>';
  };

  /* --- 전체 화면 (2026-10-01) ---
     Fullscreen API: 안드로이드 크롬은 주소창과 하단 내비게이션 막대까지 숨긴다(navigationUI:'hide'),
     PC 는 F11 과 같고, 아이패드 사파리는 webkit 접두어로 된다. 아이폰 사파리는 영상 말고는 전체 화면을
     허용하지 않아 '홈 화면에 추가' 안내를 띄운다. 페이지를 새로 불러오면 브라우저가 전체 화면을 푼다(표준 동작). */
  function fsEl(){ return document.fullscreenElement || document.webkitFullscreenElement || null; }
  function fsCan(){ var d=document.documentElement; return !!((d.requestFullscreen && document.fullscreenEnabled !== false) || d.webkitRequestFullscreen); }
  function fsSay(m, ms){ try{ if(PIA.toast) PIA.toast(m, ms||5000); }catch(e){} }
  PIA.isFullscreen = function(){ return !!fsEl(); };
  PIA.toggleFullscreen = function(){
    var d=document.documentElement;
    try{
      if(fsEl()){
        var x = document.exitFullscreen || document.webkitExitFullscreen;
        var q = x && x.call(document); if(q && q.catch) q.catch(function(e){ console.error('[전체 화면] 끝내기 실패', e); });
        return;
      }
      if(!fsCan()){
        var ios = /iPhone|iPod/i.test(navigator.userAgent);
        fsSay(ios ? '아이폰은 브라우저 제한으로 전체 화면이 안 돼요. 사파리 아래 공유(□↑) → \'홈 화면에 추가\'로 열면 주소창 없이 쓸 수 있어요.'
                  : '이 브라우저는 전체 화면을 지원하지 않아요.', 8000);
        return;
      }
      var p = d.requestFullscreen ? d.requestFullscreen({ navigationUI: 'hide' }) : d.webkitRequestFullscreen();
      if(p && p.catch) p.catch(function(e){ console.error('[전체 화면] 켜기 실패', e); fsSay('전체 화면을 켜지 못했어요. 다시 눌러 주세요.'); });
    }catch(e){ console.error('[전체 화면] 오류', e); fsSay('전체 화면을 켜지 못했어요.'); }
  };
  function fsSync(){
    var b=document.getElementById('pia-fullscreen-btn'); if(!b) return;
    var on=!!fsEl();
    b.setAttribute('aria-pressed', on?'true':'false');
    b.title = on ? '전체 화면 끝내기 (Esc)' : '전체 화면 — 주소창·메뉴 없이 크게';
  }
  document.addEventListener('fullscreenchange', fsSync);
  document.addEventListener('webkitfullscreenchange', fsSync);

  /* --- 접근성: 글자 크게 --- */
  PIA.toggleFontSize = function(){
    var h=document.documentElement, on=h.getAttribute('data-pia-fs')==='l';
    h.setAttribute('data-pia-fs', on?'':'l');
    try{ localStorage.setItem('pia_fs', on?'':'l'); }catch(e){}
    var b=document.getElementById('pia-fs-btn'); if(b) b.setAttribute('aria-pressed', on?'false':'true');
  };
  try{ if(localStorage.getItem('pia_fs')==='l') document.documentElement.setAttribute('data-pia-fs','l'); }catch(e){}

  /* --- 접근성: 음성 안내 (기존 piaSpeak 재사용) --- */
  PIA.ttsOn = true;  /* 기본값: 화면 진입 시 자동으로 읽어준다. 버튼으로 언제든 음소거 가능 (2026-09-03) */
  PIA.toggleTTS = function(){
    PIA.ttsOn = !PIA.ttsOn;
    var b=document.getElementById('pia-tts-btn'); if(b) b.setAttribute('aria-pressed', PIA.ttsOn?'true':'false');
    try{ localStorage.setItem('pia_tts', PIA.ttsOn?'1':'0'); }catch(e){}
    if(PIA.ttsOn){
      var _t = PIA.currentReadText() || '음성 안내를 켰습니다.';
      /* 감시 로직이 같은 문구를 또 읽지 않도록 같은 기준으로 기록 */
      PIA._lastRead = (PIA._norm ? PIA._norm(_t) : _t);
      PIA.speak(_t);
    }
    else { try{ if(window.speechSynthesis) speechSynthesis.cancel(); }catch(e){} }
  };
  /* 브라우저 내장 음성을 직접 사용한다.
     외부 TTS(구글 번역 음성)는 학교·키오스크 망에서 오류 없이 조용히 실패해
     소리가 전혀 나지 않는 일이 있어 기본 경로에서 제외했다. */
  PIA.speak = function(t){
    /* 그림문자는 어떤 경로로 들어와도 읽지 않는다 */
    try{ if(PIA._stripArt) t = PIA._stripArt(t); }catch(e){}
    if(!t) return;
    if(!('speechSynthesis' in window)){ if(window.console) console.error('이 브라우저는 음성 합성을 지원하지 않습니다.'); return; }
    var notified=false;
    function notifyFail(why){
      if(notified) return; notified=true;
      var msg='이 기기에서 음성이 재생되지 않습니다. 소리(볼륨)와 한국어 음성 설치 상태를 확인해 주세요.';
      try{
        var ko=(speechSynthesis.getVoices()||[]).filter(function(v){ return /ko/i.test(v.lang); });
        if(!ko.length) msg='이 기기에 한국어 음성이 설치되어 있지 않아 읽어 줄 수 없습니다.';
      }catch(e){}
      if(window.console) console.error('[음성 안내]', msg, '(원인:'+why+')');
      try{ if(window.PIA && PIA.toast) PIA.toast(msg, 6000); }catch(e){}
    }
    function say(){
      try{
        /* 뒤이어 새 안내가 들어와 이 발화가 밀려나면 onstart 가 오지 않는다.
           예전에는 그때도 1.8초 뒤 '음성이 재생되지 않습니다' 토스트가 떠서
           정상 동작을 고장으로 알렸다. 세대 번호로 구분한다. (2026-09-05) */
        var _myGen = (PIA._sayGen = (PIA._sayGen || 0) + 1);
        var u=new SpeechSynthesisUtterance(String(t));
        u.lang='ko-KR'; u.rate=0.95; u.pitch=1.05;
        if(typeof window.piaApplyVoice==='function') window.piaApplyVoice(u);
        var ok=false;
        u.onstart=function(){ ok=true; };
        u.onerror=function(e){
          var why=(e&&e.error)||'unknown';
          if(window.console) console.error('음성 재생 실패:', why);
          if(why!=='interrupted' && why!=='canceled') notifyFail(why);
        };
        try{ speechSynthesis.cancel(); }catch(e){}
        speechSynthesis.speak(u);
        /* 발화 시작 신호가 없으면 소리가 안 난 것으로 보고 안내 */
        setTimeout(function(){
          if(_myGen !== PIA._sayGen) return;      /* 새 안내에 밀려남 — 고장이 아니다 */
          if(window.__gttsPlaying) return;        /* 지금 다른 음성이 나오는 중 */
          if(!ok && PIA.ttsOn) notifyFail('nostart');
        }, 1800);
      }catch(e){ if(window.console) console.error('음성 재생 오류:', e); }
    }
    try{
      var vs=speechSynthesis.getVoices();
      if(!vs || !vs.length){
        /* 음성 목록이 아직 준비되지 않았으면 준비된 뒤에 읽는다 */
        var done=false;
        var once=function(){ if(done) return; done=true;
          try{ speechSynthesis.removeEventListener('voiceschanged', once); }catch(e){} say(); };
        try{ speechSynthesis.addEventListener('voiceschanged', once); }catch(e){}
        setTimeout(once, 800);
        return;
      }
      say();
    }catch(e){ say(); }
  };
  PIA.currentReadText = function(){
    var s=document.querySelector('section[data-view]:not(.hidden)'); if(!s) return '';
    var q=s.querySelector('.pia-q'); if(q) return q.textContent.trim();
    var h=s.querySelector('.pia-h1,.pia-display,.pia-h2'); return h?h.textContent.trim():'';
  };
  PIA.autoRead = function(){ if(PIA.ttsOn){ var t=PIA.currentReadText(); if(t) PIA.speak(t); } };
  try{ if(localStorage.getItem('pia_tts')==='0') PIA.ttsOn=false; }catch(e){}

  /* --- 도움 화면 (2026-10-01 OWNER '도움버튼을 누르면 나갈 방법이 없어') ---
     예전: 도움 화면에 돌아가기 버튼이 없어 검사·대화 중에 누르면 되돌아갈 길이 없었다.
     지금: 도움을 열기 직전 화면을 기억해 두고 '돌아가기'(위·아래), 머리 '도움' 다시 누르기, Esc 로 그 화면으로 돌아간다.
     직전 화면은 화면 전환(섹션 hidden 변화)을 지켜보며 기록한다 — 채팅의 상담센터 안내처럼
     showView('help') 를 직접 부르는 경로도 똑같이 돌아갈 수 있게. */
  var _lastView = 'home';
  function _visView(){ var s=document.querySelector('section[data-view]:not(.hidden)'); return s ? s.getAttribute('data-view') : ''; }
  function _goView(n){
    try{
      if(typeof window.showView==='function'){ window.showView(n); return; }
      document.querySelectorAll('section[data-view]').forEach(function(s){ s.classList.toggle('hidden', s.getAttribute('data-view')!==n); });
    }catch(e){ console.error('[도움] 화면 전환 실패', e); }
  }
  function _helpBtnSync(){ var b=document.getElementById('pia-help-btn'); if(b) b.setAttribute('aria-pressed', _visView()==='help'?'true':'false'); }
  function _watchViews(){
    try{
      var mo=new MutationObserver(function(){ var v=_visView(); if(v && v!=='help') _lastView=v; _helpBtnSync(); });
      document.querySelectorAll('section[data-view]').forEach(function(s){ mo.observe(s, { attributes:true, attributeFilter:['class'] }); });
      var v=_visView(); if(v && v!=='help') _lastView=v;
    }catch(e){ console.error('[도움] 화면 감시 설치 실패', e); }
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', _watchViews); else _watchViews();
  PIA.helpReturnView = function(){ return _lastView; };
  PIA.openHelp = function(){
    if(_visView()==='help'){ PIA.closeHelp(); return; }
    var v=_visView(); if(v) _lastView=v;
    _goView('help');
    try{ window.scrollTo(0,0); }catch(e){}
    _helpBtnSync();
  };
  PIA.closeHelp = function(){
    _goView(_lastView && _lastView!=='help' ? _lastView : 'home');
    try{ window.scrollTo(0,0); }catch(e){}
    _helpBtnSync();
  };
  document.addEventListener('keydown', function(e){
    if(e.key==='Escape' && _visView()==='help' && !document.querySelector('[role="dialog"][aria-modal="true"]')) PIA.closeHelp();
  });

  /* [CSP 2026-09-29] 이 모듈의 버튼 API 는 옛날부터 동작을 코드 문자열("fn()" · "fn('x')")로 받는다.
     엄격 CSP 에서는 onclick 속성을 쓸 수 없어, 그 문자열을 data-act 로 바꾼다(web/csp-actions.js 가 처리). */
  function actAttr(code){
    var m = /^\s*([A-Za-z_$][\w$.]*)\(\s*(?:'([^']*)'|"([^"]*)")?\s*\)\s*;?\s*$/.exec(String(code || ''));
    if (!m) { console.error('[PIA] data-act 로 바꿀 수 없는 동작: ' + code); return ''; }
    var arg = m[2] !== undefined ? m[2] : m[3];
    return ' data-act="' + esc(m[1]) + '"' + (arg !== undefined ? ' data-arg="' + esc(arg) + '"' : '');
  }

  /* --- Back navigation --- */
  PIA.back = function(label, action){
    return '<button type="button" class="pia-back"'+actAttr(action)+'>'+IC.back+esc(label)+'</button>';
  };

  /* --- Progress bar --- */
  PIA.progress = function(label, cur, total, opt){
    opt = opt || {};
    var pct = total>0 ? Math.round(cur/total*100) : 0;
    var pctHtml = (opt.pct===false)
      ? '<span class="pia-sr">'+pct+'%</span>'
      : '<span class="pia-prog__pct">'+pct+'%</span>';
    return '<div class="pia-prog'+(opt.compact?' pia-prog--compact':'')+'">'
      + '<div class="pia-prog__top"><span class="pia-prog__label">'+esc(label)+' <b class="pia-prog__cur">'+cur+'</b> <span class="pia-prog__tot">/ '+total+'</span></span>'
      + pctHtml+'</div>'
      + '<div class="pia-prog__bar" role="progressbar" aria-valuenow="'+pct+'" aria-valuemin="0" aria-valuemax="100" aria-label="'+esc(label)+' 진행률">'
      + '<div class="pia-prog__fill" style="width:'+pct+'%"></div></div></div>';
  };

  /* --- Badge --- */
  PIA.badge = function(txt, kind){
    return '<span class="pia-badge'+(kind?' pia-badge--'+kind:'')+'">'+esc(txt)+'</span>';
  };

  /* --- Choice card (Radio + Check + Text) --- */
  PIA.choice = function(txt, onclick, checked){
    return '<button type="button" role="radio" aria-checked="'+(checked?'true':'false')+'" class="pia-choice"'+actAttr(onclick)+'>'
      + '<span class="pia-choice__radio" aria-hidden="true"></span>'
      + '<span class="pia-choice__txt">'+esc(txt)+'</span>'
      + '<span class="pia-choice__ck" aria-hidden="true">✓</span></button>';
  };

  /* --- Autosave indicator --- */
  PIA.autosave = function(txt){
    return '<p class="pia-autosave">'+IC.save+(txt||'답변은 자동으로 저장돼요')+'</p>';
  };

  /* --- Footer action bar --- */
  PIA.fab = function(btns){
    return '<div class="pia-fab">'+btns.join('')+'</div>';
  };
  PIA.btn = function(label, onclick, variant, opt){
    opt = opt||{};
    var cls='pia-btn pia-btn--'+(variant||'primary')+(opt.cta?' pia-btn--cta':'');
    var dis = opt.disabled ? ' disabled aria-disabled="true"' : '';
    var ar = opt.arrow ? '<span class="pia-btn__ar" aria-hidden="true">›</span>' : '';
    return '<button type="button" class="'+cls+'"'+dis+''+actAttr(onclick)+'>'+esc(label)+ar+'</button>';
  };
})();

